import { Component, OnInit, Input } from '@angular/core';
import { VennHealthDataService } from '../../../services/vennhealth-data.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from '../../../services/shared.service';
import { SavedQueriesModel } from '@app/models/filter-model';
import { IndicationGroup } from '@app/models/indication';

@Component({
  selector: 'app-previous-queries',
  templateUrl: './previous-queries.component.html',
  styleUrls: ['./previous-queries.component.css']
})
export class PreviousQueriesComponent implements OnInit {

  loading = false;
  executedQueriesData: SavedQueriesModel[] = [];
  allIndications: IndicationGroup[] = [];

  constructor(
    private readonly vennHealthDataService: VennHealthDataService,
    private readonly ngxSpinner: NgxSpinnerService,
    private readonly sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.ngxSpinner.show('previousQueriesSpinner');
    this.refreshPreviousQueriesSubscription();

    this.sharedService.refreshQueryHistory.subscribe(data => {
      if (data !== null && data === true) {
        this.refreshPreviousQueriesSubscription();
      }
    });
  }

  refreshPreviousQueriesSubscription(): void {
    this.loading = true;
    this.vennHealthDataService.getExecutedQueriesList().subscribe({
      next: (response) => {
        if (response !== null) {
          this.executedQueriesData = response;
          //this.sharedService.setLastExecutedQueryInfo(response[0]);
        }
      },
      error: (e) => { 
        this.ngxSpinner.hide('previousQueriesSpinner');
      this.loading = false;
      },
      complete: () => {
        this.ngxSpinner.hide('previousQueriesSpinner');
        this.loading = false;
      }
    });
  }
}
